// modules/timestamp/index.ts
var timestampNow = () => (/* @__PURE__ */ new Date()).toISOString();
var timestampFromDate = (date) => date.toISOString();
var timestampToDate = (timestamp) => new Date(timestamp);
function parseTimestamp(value) {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : timestampFromDate(parsed);
}
export {
  parseTimestamp,
  timestampFromDate,
  timestampNow,
  timestampToDate
};
